module.exports = __webpack_public_path__ + "img/_5.fe8e985a.png";